/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * This component makes sure that the element is on the page (fully loaded), when switching pages with hashes.
 * The problem it resolves is: When navigation from page a to page b#anchor, because the SPA can take some time to fully
 * render the new page, the element can initially be missing. This component retries for a specified time to find that element,
 * if it cannot be found after this, it does nothing
 */
export const ScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const retryInterval = 50;
    // Retires needed to try for 5 seconds, with retry Interval
    let maxRetiresLeft = 5000 / retryInterval;

    function scroll() {
      const element = document.getElementById(hash.replace("#", ""));

      maxRetiresLeft -= 1;

      if (maxRetiresLeft <= 0) {
        clearInterval(interval);
        return;
      }

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        clearInterval(interval);
      }
    }

    if (hash) {
      scroll();
      interval = setInterval(scroll, retryInterval);
    }

    return ()=> clearInterval(interval);
  }, [hash]);

  return null;
};
